export const PIN_BLOCKED_BY_DUPLICATE =
  "A column reviewers can duplicate cannot be pinned; its copies would sit away from it at the right edge. Turn off “Can duplicate” first.";

export const DUPLICATE_BLOCKED_BY_PIN =
  "A pinned column cannot be duplicated; its copies would be pulled to the right edge too. Turn off “Always show on the right” first.";

export const pinBlockedByGroup = (groupName) =>
  `Columns in the “${groupName}” group cannot be pinned: a pinned column moves to the end of the table, away from its band. Remove it from the group first.`;

export const isGrouped = ({ groupId, groupKey }) =>
  groupId != null || groupKey != null;

export const findColumnGroup = (column, groups = []) => {
  const groupKey = column.groupId ?? column.groupKey;
  if (groupKey == null) {
    return null;
  }
  return (
    groups.find(
      (group) => (group.id ?? group.clientKey ?? group.key) === groupKey
    ) ?? null
  );
};

export const getPinBlockedReason = (column, group = null) => {
  if (isGrouped(column)) {
    return pinBlockedByGroup(group?.name ?? "");
  }
  return column.repeatable ? PIN_BLOCKED_BY_DUPLICATE : null;
};

export const getDuplicateBlockedReason = (column) =>
  column.pinned ? DUPLICATE_BLOCKED_BY_PIN : null;

export const withoutBrackets = (name) => name.replace(/[[\]]/g, "");

export const getColumnLabel = (column) =>
  column.renamable ? `[${column.name}]` : column.name;

export const withoutPinForGroup = (column) => ({
  column: column.pinned ? { ...column, pinned: false } : column,
  unpinned: Boolean(column.pinned),
});
